import React, {useEffect, useState} from 'react';
import {
  Grid,
  TextField, Stepper, Step, Popper, Fade, StepLabel,
  Paper, Typography, Autocomplete, Alert, AlertTitle, Box, InputAdornment,
  Button, MenuItem, InputLabel,Select, FormControl, FormHelperText
} from '@mui/material';



import { useSelector,useDispatch } from 'react-redux';


import { visitorsSyncLoaded,
  selectVisitorByEmail, fetchAllVisitors } from '../store/visitorSlice';


import {usePlayContext} from '../utils/PlayContext';

import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';

import { createVisitor, updateVisitor, selectAllVisitors, selectAllCompanies,  selectVisitorById}
from '../store/visitorSlice';

import {regexEmail, regxPhone, regxLocalPhone, localPhoneError, phoneHelpText,
  regxCountyCode, regxPhoneNumber
} from '../utils/ValidationConst'

import { derivePhone, generatePhoneDetail } from '../utils/phoneUtil';


const VisitorEditPage = ({action}) => {

  const location = useLocation();

  const navigate = useNavigate()
  const {id} = useParams()
  const visitorId = parseInt(id)
  console.log("visitorId = useParams()="+visitorId)
  const allCompanies = useSelector(selectAllCompanies)

  const visitor = useSelector(selectVisitorById(visitorId))

  const allVisitors = useSelector(selectAllVisitors)

  const {
      setOp,
      status, setStatus, appTitle, setAppTitle, 
      errorMessage, setErrorMessage, errorTitle, setErrorTitle,
      openSnackToast
    }=usePlayContext()

  const dispatch = useDispatch()

  const [name, setName] = useState(visitor?visitor.name : '');
  const [nameError, setNameError] = useState('');
  
  const [email, setEmail] = useState(visitor?visitor.email:'');
  const [emailError, setEmailError] = useState('');


  const [countryCode, setCountryCode] = React.useState(visitor? visitor.countryCode:'65')
  const [countryCodeError, setCountryCodeError] = React.useState('')
  const [phoneNumber, setPhoneNumber] = React.useState(visitor? visitor.phoneNumber:'')
  const [phoneNumberError, setPhoneNumberError] = React.useState('');

  
  const [company, setCompany] = useState(visitor?visitor.company:'');
  const [companyError, setCompanyError] = useState('');


 const isPhoneNumberValid=Boolean(phoneNumber) && phoneNumber.match(regxPhoneNumber) 
 const isCountryCodeValid = !Boolean(countryCode) || countryCode.match(regxCountyCode)
 const isEmailValid=Boolean(email) && email.match(regexEmail)


  const onCancelClicked = ()=>{
    if (action==='create')
      navigate('/visitor')
    else
    navigate(-1)

  }


  useEffect(() => {
    setAppTitle(  ['Visitors', (action==='create' ? 'Create': 'Edit'), id])
    
    setErrorMessage('')
    setErrorTitle('')

    setOp('')
    //doFetchData();

    return () => {
      setErrorMessage('')
      setErrorTitle('')
        setOp('')
      
    }

  }, [])

 
  const doCreate = async()=>
  {
    setErrorMessage('')
    setErrorTitle('')

     let err=0
     const email1=email.toLocaleLowerCase()
    
     if (!Boolean(name) || !Boolean(name.trim()) )
     {
         err++
         setNameError('Name is required')
     }
     else if(name.length>30)
     {
       err++
       setNameError('Name cannot exceed 30 letters')
     }
     else if(name.length<3)
     {
        err++
       setNameError('Name cannot less than 3 letters')
     }else if(!isNaN(name))
     {
        err++
       setNameError('Name cannot be number only')
     }
    else setNameError('');

     if (!Boolean(company) || !Boolean(company.trim()) )
     {
         err++
         setCompanyError('Company is required')
     }
     else if(company.length>50)
      {
        err++
        setCompanyError('Company cannot exceed 50 letters')
      }
     else setCompanyError('')


     if (!isEmailValid)
     {
        err++
        setEmailError('Email is invalid')
     }
     else
     {
        setEmailError('')
        let x = allVisitors.find(x=>x.email === email1)
        if (x)
        {
        
          if (action==='create' || (action==='edit' && visitorId!==x.id))
          {
            setEmailError('The email already exist')
            err++;
          }
        }
      }

	  //PHONE+COUNTRY_CODE
      let countryCode1 = Boolean(countryCode) ? countryCode : '65' 

      if (!isCountryCodeValid)
      {
          err++
          setCountryCodeError('Invalid')
      }
      else setCountryCodeError('')
      
      if (!Boolean(phoneNumber))
      {
        err++
        setPhoneNumberError('Phone Number is required')
      }
      else if (!isPhoneNumberValid)
      {
          err++
          setPhoneNumberError('Phone Number invalid')
      }
      else setPhoneNumberError('')

      let phone1
      let phone2
      
      let phoneDisplay
	  if ('65'=== countryCode1)
    {
        phone1 = phoneNumber
        phone2= "+65 "+phoneNumber
        phoneDisplay = '+65-'+phoneNumber
    }
    else
    {
        phone2 = phone1 = '+'+countryCode1+' '+phoneNumber;
        phoneDisplay = '+'+countryCode1+'-'+phoneNumber;
    }
      if (err>0) return;

     setPhoneNumberError('')
	  let x = allVisitors.find(x=>(x.phone === phone1 || x.phone === phone2))
      if (x)
      {
          if (action==='create' ) 
          {
                setPhoneNumberError('The phone number already exist')
                err++;
          }
          else if (action==='edit' && visitorId!==x.id)
          {
            setPhoneNumberError('This phone number already exist--'+visitorId+"--"+x.id)
                err++;
          } 
      }





	  if (err>0) return;



      setStatus('processing')
      setEmailError('')
      setCountryCodeError('')
      setPhoneNumberError('')
      

      try
      {
        
        let vv = {
          email:email1,
	        name:name.trim(),
          company:company.trim(),
          phone : phone1,
        };
        
        
        if (action==='edit')
        {
            vv.id=visitorId;
            
            let vvv1 = await dispatch(updateVisitor(vv)).unwrap()

        }
        else
        {
          let vvv1 = await dispatch(createVisitor(vv)).unwrap()

        }
 

        setStatus('success')
        setOp('')
        

        let mesg = "Visitor has been "+('create'===action ? 'created':'updated')
        openSnackToast(mesg)

        if ('create'===action)
        {
          navigate("/visitor")
        }
        else
        {
          navigate(-1)
        }

      }
      catch (ex){
        setErrorMessage("Visitor "+action+" Error")
        setStatus('error')
        console.error("xxx::"+ex.message);

      }
  }

  return (
    <Box sx={{width:'100%', mt:1}}>
      
      <Paper sx={{border:'none', p: 1, m:1, 
            bgcolor:'none'}} elevation={1} >
        
        <Grid
          container
          spacing={1}
          sx={{bgcolor:'none', mt:1}}
          direction={'row'}
          alignItems={'center'}
        >
        <Grid item xs={12} md={6} lg={4}  sx={{ m:0, p:1 , bgcolor:'none'}}>
          <TextField 
                size='small'
                required
                  fullWidth  variant='outlined'
               value={name}
               error={Boolean(nameError)}
               onChange={e=>setName(e.target.value)}
              id="id_name"
              aria-describedby="id_name_text"
              label='Name'
              helperText={ Boolean(nameError) ? nameError:"Name (required)"}
            
            />
        </Grid>
      
        <Grid item xs={12} md={6} lg={4}  sx={{ m:0, p:1 }}>
          <TextField 
                size='small'
                required
                  fullWidth  variant='outlined'
               value={email}
			   error={Boolean(emailError)}
               onChange={e=>setEmail(e.target.value)}
              id="id_name"
              aria-describedby="id_email_text"
              label='Email'
              helperText={ Boolean(emailError) ? emailError:"Email (required)"}
            
            />
        </Grid>
      
        <Grid container item xs={12} md={6} lg={4}  sx={{ m:0, p:1, display:'inline-flex' }}>
          <Grid item xs={5}>
                <TextField
                    fullWidth
                    required
                    size='small'
                    label={<small>Country Code</small>}
                    type="number"
                    id="id_phone_counter_code"
                    value={countryCode}
                    onChange={e=>setCountryCode(e.target.value)}
                    error={Boolean(countryCodeError)}
                    inputProps= {{ 
                      max: 999, min: 1 ,
                      maxLength:3
                    }}
                  InputProps={{
                    startAdornment: <InputAdornment position="start"><strong>+</strong></InputAdornment>,
                  }}
                  helperText={<small>{ Boolean(countryCodeError) ? countryCodeError:'Country Code(required)'}
                  </small>}
                  />
                </Grid>
                <Grid item xs={7} sx={{}}>
                <TextField
                    fullWidth
                    error={Boolean(phoneNumberError)}
                    sx={{mx:0.5}}
                    value={phoneNumber}
                    onChange={e=>setPhoneNumber(e.target.value)}
                    required
                      size='small'
                      label="Phone Number"
                      type="number"
                      id="id_phone_number"
                      helperText={ Boolean(phoneNumberError)?phoneNumberError:'Phone Number(required)' }
                />
                </Grid>
        </Grid>
      
         
        <Grid item xs={12} md={6} lg={4}  sx={{ m:0, p:1 }}>
          <Autocomplete 
                fullWidth
                freeSolo
                size='small'
                id="id_company" 
                
                value={company}
                //getOptionLabel={ (option) => option}
                options={allCompanies} 
                //onChange = { (e, newValue)=>{;   } }
                onChange = { (e, newValue)=>{setCompany(newValue);}}
                renderInput={(params) => 
                    <TextField {...params} 
                      required
                      onChange = { e=>{setCompany(e.target.value);}}
                      error={Boolean(companyError)}
                      label="Organization"  
                      
                      //inputProps={{ maxLength: 100, minLength:5 }}
                      helperText={ Boolean(companyError)? companyError:"Organization (required}"}
                      />}

                />
        </Grid>
      
      

      </Grid>

          
          
        
        <Box sx={{mt:1,display:'flex', width:'100%', justifyContent: 'space-around'}}>

            <Button variant="outlined" 
            //variant="contained" 
            color='success'  
              //disabled = {status==='success'}
              onClick={doCreate}
            > {action==='edit' ? 'Update': 'Create'} </Button>

            <Button variant="outlined" 
            //variant="contained" 
            color='success' 
              //disabled = {status==='success'}
              onClick={onCancelClicked}
            > Cancel</Button>

        </Box>
      
      </Paper>
      

      
    </Box>
  );
};

export default VisitorEditPage

